module.exports = __webpack_public_path__ + "img/03扬帆计划.e11b3bff.png";